<template>
  <div class="home mx-auto" v-if="bonoActual">

    <Landing :datos="bonoActual" />
   
  </div>
</template>

<script>
// @ is an alias to /src
// import Landing from '@/components/LandingBerriz.vue'
import Landing from '@/components/Landing.vue'
// import Landing from '@/components/LandingDenda.vue'

export default {
  name: 'Home',
  components: {
    Landing
  },
  computed: {
    bonoActual() {
      return this.$store.state.bonoActual;
    },
  }
}
</script>
